var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-2 d-flex",staticStyle:{"margin-left":"3.95rem","flex-wrap":"wrap"}},_vm._l((_vm.visibleTags),function(item){return _c('TagV2',{key:item.id,attrs:{"data":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }